(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[52923],{

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35533);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39717);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function FeatureList({ featureList , mainTitle , mainDescription , colors , classes  }) {
    const outerSectionStyle = {
        "--bg": `${colors?.bgColor ?? "transparent"}`,
        "--iconColor": `${colors?.iconColor ?? "gray"}`
    };
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: outerSectionStyle,
        className: `mt-10 lg:mt-16 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainSection)} `,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes?.mainSectionClasses ?? "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: colors?.mainTitleColor ?? "black"
                    },
                    className: classes?.mainTitleClasses ?? "text-center text-xl lg:text-2xl mb-14",
                    children: mainTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: colors?.mainDescriptionColor ?? "black"
                    },
                    className: classes?.mainDescriptionClasses ?? "",
                    children: mainDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes?.innerSectionClasses ?? "lg:flex flex-wrap justify-center",
                    children: featureList?.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classes?.oneBoxClasses ? `${classes?.oneBoxClasses} ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""}` : `text-center mb-12 lg:mb-20 w-full lg:w-1/3   ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""} `,
                            children: [
                                item.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes?.iconClasses ?? "relative mb-14 w-[190px] h-[190px]  mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.path,
                                        layout: "fill",
                                        alt: item.title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes?.iconClasses ?? "children:w-12 children:h-12 children:mx-auto ",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    style: {
                                        color: colors?.titleColor ?? "black"
                                    },
                                    className: classes?.titleClasses ?? "font-medium text-lg lg:text-xl mt-6",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        color: colors?.descriptionColor ?? "black"
                                    },
                                    className: classes?.descriptionClasses ?? "font-light text-sm text-center w-4/5 mx-auto mt-2",
                                    children: item.description
                                }),
                                item.tool && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: `/tools/${item.tool}?${(0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start")}`,
                                    className: classes?.toolClasses ? `${classes?.toolClasses} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}` : `mt-4 flex gap-2 items-center md:mt-auto ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}`,
                                    style: {
                                        color: colors?.toolColor ?? "black"
                                    },
                                    children: [
                                        "Details",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "transform rotate-180",
                                            fill: colors?.chevronColor
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 52923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SideEffects; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/styles/variables/tepezzaVariables.module.scss
var tepezzaVariables_module = __webpack_require__(71020);
var tepezzaVariables_module_default = /*#__PURE__*/__webpack_require__.n(tepezzaVariables_module);
;// CONCATENATED MODULE: ./src/components/tepezza/sideEffects/icons/hearingLoss.tsx


function HearingLoss() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "111",
        height: "111",
        fill: "none",
        viewBox: "0 0 111 111",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_d_3_86)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "55.5",
                        cy: "51.5",
                        r: "51.5",
                        fill: "#1E4E35"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "mask0_3_86",
                        style: {
                            maskType: "alpha"
                        },
                        width: "50",
                        height: "50",
                        x: "30",
                        y: "27",
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#D9D9D9",
                            d: "M30 27H80V77H30z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        fill: "#fff",
                        mask: "url(#mask0_3_86)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M45.893 56.82a1.035 1.035 0 001.5 0 1.035 1.035 0 000-1.5c-1.393-1.393-3.697-1.393-5.143 0-1.393 1.393-1.393 3.697 0 5.143 1.178 1.179 1.5 1.553 1.5 2.84a3.646 3.646 0 003.642 3.642 3.612 3.612 0 003.643-3.643c0-.59-.483-1.072-1.072-1.072-.59 0-1.072.483-1.072 1.072 0 .804-.643 1.5-1.5 1.5-.856 0-1.5-.643-1.5-1.5 0-2.089-.803-3-2.142-4.339a1.497 1.497 0 01-.429-1.071c0-.43.16-.75.429-1.072.59-.59 1.555-.59 2.144 0z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M71.714 37.75a8.253 8.253 0 00-8.25-8.25c-3.16 0-5.893 1.768-7.286 4.393a14.806 14.806 0 00-3.053-.321c-8.09 0-14.625 6.59-14.625 14.625v3.053c0 .59.482 1.072 1.072 1.072.589 0 1.071-.482 1.071-1.072v-3.053c0-6.91 5.625-12.483 12.483-12.483.803 0 1.553.054 2.303.215-.107.589-.214 1.178-.214 1.768 0 .214 0 .375.053.589a9.23 9.23 0 00-2.089-.214c-4.928 0-8.893 4.018-8.893 8.892 0 2.946 2.143 5.036 3.858 6.697.16.16.375.32.536.535.214.215.482.322.75.322.267 0 .535-.108.75-.322a1.035 1.035 0 000-1.5l-.536-.535c-1.554-1.553-3.215-3.107-3.215-5.197 0-3.75 3.054-6.75 6.75-6.75.91 0 1.822.161 2.625.43.857 2.25 2.732 4.07 5.036 4.874.321.91.536 1.875.536 2.893 0 3.535-1.447 4.874-3.482 6.803-.43.429-.483 1.072-.054 1.5.214.214.482.32.804.32.267 0 .535-.106.75-.267 2.142-1.982 4.178-3.91 4.178-8.356a9.44 9.44 0 00-.321-2.465h.32c.644 0 1.287-.107 1.876-.214.16.803.268 1.607.268 2.465 0 5.41-2.625 7.82-4.929 10.017-1.821 1.715-3.535 3.321-3.535 5.893a8.253 8.253 0 01-8.25 8.25 8.253 8.253 0 01-8.25-8.25c0-.59-.482-1.072-1.071-1.072-.59 0-1.072.483-1.072 1.072 0 5.732 4.66 10.393 10.393 10.393 5.733 0 10.393-4.66 10.393-10.393 0-1.66 1.286-2.839 2.84-4.339 2.517-2.357 5.624-5.25 5.624-11.57 0-1.126-.107-2.197-.375-3.215 2.463-1.34 4.23-4.073 4.23-7.233zm-8.25 7.178c-.214 0-.429 0-.643-.053-1.018-.107-1.928-.376-2.785-.857-1.126-.643-2.09-1.554-2.732-2.679a8.19 8.19 0 01-.964-2.785c-.054-.268-.054-.59-.054-.857 0-.536.054-1.072.16-1.553.161-.697.43-1.393.804-1.983 1.232-2.142 3.536-3.642 6.214-3.642a7.179 7.179 0 017.179 7.178c0 2.625-1.447 4.928-3.536 6.16-.59.376-1.286.644-1.982.804-.536.214-1.072.267-1.661.267z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M66.946 40.482l-2.732-2.732 2.732-2.732a.518.518 0 000-.75.518.518 0 00-.75 0L63.464 37l-2.732-2.732a.518.518 0 00-.75 0 .518.518 0 000 .75l2.678 2.678-2.732 2.732c-.053.054-.107.107-.107.16-.107.215-.053.43.107.59.107.107.268.16.376.16.107 0 .16 0 .214-.053.053 0 .107-.053.16-.107l2.732-2.732 2.679 2.679c.107.107.267.16.375.16a.581.581 0 00.375-.16c.321-.107.321-.428.107-.643z"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter0_d_3_86",
                    width: "111",
                    height: "111",
                    x: "0",
                    y: "0",
                    colorInterpolationFilters: "sRGB",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            result: "hardAlpha",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            dy: "4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: "2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_3_86"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_3_86",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var hearingLoss = (HearingLoss);

;// CONCATENATED MODULE: ./src/components/tepezza/sideEffects/icons/deafness.tsx


function Deafness() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "103",
        height: "103",
        fill: "none",
        viewBox: "0 0 103 103",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "51.5",
                cy: "51.5",
                r: "51.5",
                fill: "#1E4E35"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_4_88",
                style: {
                    maskType: "alpha"
                },
                width: "50",
                height: "50",
                x: "26",
                y: "27",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26 27H76V77H26z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#fff",
                mask: "url(#mask0_4_88)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M38.91 41.671a17.328 17.328 0 00-.45 4.019c0 4.148 1.14 6.052 4.487 8.865a202.2 202.2 0 011.59 1.335c3.475 2.995 5.384 5.869 6.358 10.736 1.531 7.658 12.033 7.231 12.47-.499l-2.5-2.5c-.442 4.9-7.454 4.735-7.454-.494 0-3.389-.964-5.221-3.367-7.594-.167-.165-.809-.788-.958-.936-2.055-2.025-3.014-3.577-3.137-5.891l-7.04-7.04zm26.639 26.64c-2.21 8.692-15.145 8.567-17.098-1.196-.854-4.266-2.456-6.679-5.542-9.337-.36-.312-1.785-1.5-1.566-1.316-3.86-3.243-5.376-5.776-5.376-10.773 0-2.252.326-4.27.908-6.052l-10.51-10.51a1.246 1.246 0 011.762-1.762L75.473 74.71a1.246 1.246 0 01-1.762 1.762l-8.162-8.162zM54.65 57.414c.852 1.61 1.252 3.393 1.252 5.719 0 2.076 2.492 2.076 2.492 0 0-.535.336-.99.809-1.168l-4.553-4.551zM41.108 36.84l-1.809-1.81C47.094 25.025 65.87 28.578 65.87 45.69a1.246 1.246 0 01-2.491 0c0-14.577-15.855-17.526-22.271-8.849zm8.977 8.977l-1.89-1.89c2.941-1.76 7.708-.342 7.708 4.253a1.246 1.246 0 01-2.492 0c0-2.038-1.876-2.826-3.326-2.363z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M53.757 53.014l-1.533-1.533c.279.702.807 1.273 1.533 1.533zm-1.153-4.677c.342-.496.835-.939 1.496-1.27 1.61-.805 1.803-1.19 1.803-2.623 0-3.215-2.041-4.984-4.983-4.984-2.198 0-4.037 1.012-4.71 2.484l-1.835-1.836c1.292-1.944 3.787-3.14 6.544-3.14 4.246 0 7.476 2.8 7.476 7.476 0 2.305-.638 3.58-3.18 4.852-.47.235-.673.591-.733.92l-1.878-1.879zm-7.491-3.967a1.246 1.246 0 01-1.669-1.172c0-.161.007-.32.02-.477l1.649 1.65z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var deafness = (Deafness);

;// CONCATENATED MODULE: ./src/components/tepezza/sideEffects/icons/problemsHearingNoises.tsx


function ProblemsHearingNoises() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "103",
        height: "103",
        fill: "none",
        viewBox: "0 0 103 103",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "51.5",
                cy: "51.5",
                r: "51.5",
                fill: "#1E4E35"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_3_87",
                style: {
                    maskType: "alpha"
                },
                width: "50",
                height: "50",
                x: "26",
                y: "27",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26 27H76V77H26z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_3_87)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#fff",
                    d: "M59.716 47.468l1.465-3.194a1.044 1.044 0 011.1-.595l3.33.498 1.136-2.48c.193-.423.649-.665 1.101-.597l3.324.5 1.134-2.478a1.042 1.042 0 011.894.866l-1.46 3.191a1.043 1.043 0 01-1.101.597l-3.325-.5-1.136 2.48a1.043 1.043 0 01-1.1.596l-3.33-.498-1.138 2.481a1.041 1.041 0 01-1.894-.867zm13.02 13.08a1.04 1.04 0 00-1.101-.596l-3.33.498-1.136-2.48a1.048 1.048 0 00-1.101-.596l-3.324.5-1.134-2.479a1.042 1.042 0 00-1.894.867l1.46 3.19c.193.423.648.664 1.101.597l3.325-.499 1.136 2.48a1.04 1.04 0 001.1.595l3.33-.498 1.138 2.482a1.04 1.04 0 001.381.512 1.04 1.04 0 00.513-1.38l-1.465-3.193zM55.327 36.431V67.3c0 .839-.423 1.607-1.133 2.054a2.417 2.417 0 01-2.34.14l-14.764-7.03h-7.455c-1.34 0-2.43-1.09-2.43-2.43V43.697c0-1.34 1.09-2.43 2.43-2.43h7.455l14.763-7.03a2.419 2.419 0 012.343.14 2.42 2.42 0 011.131 2.055zm-19.043 6.92h-6.649a.348.348 0 00-.347.346v16.336c0 .191.155.347.347.347h6.649V43.35zm16.96-6.92a.337.337 0 00-.162-.293.337.337 0 00-.334-.02l-14.382 6.848v17.797l14.382 6.849a.336.336 0 00.334-.02.338.338 0 00.162-.295V36.432z"
                })
            })
        ]
    });
}
/* harmony default export */ var problemsHearingNoises = (ProblemsHearingNoises);

;// CONCATENATED MODULE: ./src/components/tepezza/sideEffects/icons/skin.tsx


function Skin() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "103",
        height: "103",
        fill: "none",
        viewBox: "0 0 103 103",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "51.5",
                cy: "51.5",
                r: "51.5",
                fill: "#1E4E35"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_5_90",
                style: {
                    maskType: "alpha"
                },
                width: "50",
                height: "50",
                x: "26",
                y: "27",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26 27H76V77H26z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#fff",
                mask: "url(#mask0_5_90)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M51.333 30C39.05 30 29 40.05 29 52.333c0 12.284 10.05 22.333 22.333 22.333 11.074 0 22.333-8.933 22.333-22.333C73.666 40.05 63.616 30 51.333 30zm0 1.861c11.26 0 20.472 9.213 20.472 20.472v.745h-17.96a.893.893 0 00-.837.651l-1.954 6.421-5.304-6.607c-.186-.186-.465-.372-.744-.372H30.86v-.838c0-11.26 9.213-20.472 20.472-20.472zm0 40.944c-10.422 0-18.983-7.723-20.286-17.773H44.54l6.142 7.63c.186.187.465.373.744.373h.186c.373-.093.559-.28.745-.652l2.326-7.351h17.122c-1.395 9.957-10.05 17.774-20.472 17.774z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M50.03 50.565c1.955 0 3.63-1.582 3.63-3.629 0-2.047-1.582-3.63-3.63-3.63-1.954 0-3.629 1.583-3.629 3.63 0 2.047 1.675 3.63 3.63 3.63zm0-5.397c1.024 0 1.769.838 1.769 1.768s-.838 1.769-1.768 1.769c-.931 0-1.769-.838-1.769-1.769 0-.93.838-1.768 1.769-1.768zM58.684 62.755c-1.581 0-2.791 1.21-2.791 2.792 0 1.582 1.21 2.792 2.791 2.792 1.582 0 2.792-1.21 2.792-2.792 0-1.582-1.303-2.791-2.791-2.791zm0 3.722c-.558 0-.93-.372-.93-.93s.372-.93.93-.93c.559 0 .931.372.931.93 0 .559-.465.93-.93.93zM65.291 55.311c-1.954 0-3.629 1.582-3.629 3.63 0 2.047 1.582 3.628 3.63 3.628 1.954 0 3.629-1.581 3.629-3.629 0-2.047-1.675-3.629-3.63-3.629zm0 5.397a1.767 1.767 0 01-1.768-1.768c0-1.023.838-1.768 1.768-1.768s1.769.838 1.769 1.768-.745 1.768-1.769 1.768zM40.074 58.01c-1.955 0-3.63 1.582-3.63 3.629 0 2.047 1.582 3.629 3.63 3.629 2.047 0 3.629-1.582 3.629-3.63 0-2.046-1.675-3.628-3.63-3.628zm0 5.304a1.767 1.767 0 01-1.769-1.768c0-.93.838-1.768 1.769-1.768.93 0 1.768.837 1.768 1.768 0 .93-.745 1.768-1.768 1.768zM48.17 63.314c-1.955 0-3.63 1.582-3.63 3.629 0 2.047 1.582 3.63 3.63 3.63 2.047 0 3.628-1.583 3.628-3.63 0-2.047-1.675-3.63-3.629-3.63zm0 5.397a1.767 1.767 0 01-1.769-1.768c0-1.024.837-1.768 1.768-1.768.93 0 1.769.837 1.769 1.768 0 .93-.838 1.768-1.769 1.768zM40.632 47.68l-1.396-.279c-.465-.093-.93.186-1.117.652-.093.465.186 1.024.652 1.117l3.443.744c.186.093.465 0 .651-.093s.372-.372.372-.558l.745-3.443c.093-.466-.186-1.024-.651-1.117-.466-.093-.93.186-1.117.651l-.28 1.21-3.535-6.235a.941.941 0 00-1.21-.372.941.941 0 00-.372 1.21l3.815 6.514zM56.451 49.263c.093.279.186.465.373.558.186.093.465.186.65.093l3.444-.745c.465-.093.837-.558.651-1.116-.186-.558-.558-.838-1.116-.652l-1.303.28 3.629-6.514c.279-.465.093-1.023-.373-1.21-.465-.279-1.023-.093-1.21.373l-3.535 6.234-.28-1.21c-.093-.465-.558-.837-1.116-.65-.465.093-.837.558-.651 1.116l.837 3.443z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var skin = (Skin);

;// CONCATENATED MODULE: ./src/components/tepezza/sideEffects/icons/muscleSpasms.tsx


function MuscleSpasms() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "103",
        height: "103",
        fill: "none",
        viewBox: "0 0 103 103",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "51.5",
                cy: "51.5",
                r: "51.5",
                fill: "#1E4E35"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_4_89",
                style: {
                    maskType: "alpha"
                },
                width: "50",
                height: "50",
                x: "26",
                y: "27",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26 27H76V77H26z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#fff",
                mask: "url(#mask0_4_89)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M60.434 34.205c-1.398-.138-2.982-.296-3.31-.461-.787-.398-1.047-2.201-1.049-3.011A.73.73 0 0055.35 30h-8.7a.73.73 0 00-.726.733c0 .81-.257 2.61-1.049 3.01-.328.166-1.912.323-3.31.462-4.226.42-10.013.993-11.488 3.484-2.215 3.733-.37 18.24-.106 20.21l-.723 15.332c-.009.2.063.397.2.541a.723.723 0 00.525.228h5.075c.363 0 .67-.27.72-.635.187-1.4 1.616-12.021 2.054-16.167.356 1.749.68 3.196.89 3.834.563 1.711.687 9.412.687 12.234a.73.73 0 00.725.734h21.752a.73.73 0 00.725-.734c0-2.822.123-10.522.688-12.234.21-.639.534-2.085.89-3.834.438 4.146 1.866 14.768 2.055 16.167a.727.727 0 00.718.635h5.075a.723.723 0 00.525-.227.74.74 0 00.2-.541l-.723-15.333c.264-1.969 2.109-16.478-.105-20.209-1.476-2.492-7.264-3.066-11.489-3.485zm10.832 38.328h-3.683c-.652-4.866-2.082-15.755-2.082-16.866 0-.758-.178-2.678-.29-3.83.532-2.88.965-5.35 1.004-5.576l-1.429-.255c-.022.124-2.174 12.438-2.874 14.562-.65 1.974-.746 9.45-.76 11.965H40.846c-.014-2.515-.11-9.992-.76-11.965-.7-2.124-2.852-14.438-2.874-14.562l-1.428.255c.039.226.47 2.696 1.004 5.577-.112 1.15-.29 3.07-.29 3.828 0 1.111-1.43 12-2.083 16.867h-3.682l.689-14.632a.743.743 0 00-.006-.134c-.595-4.417-1.774-16.498-.096-19.324 1.1-1.858 6.913-2.434 10.386-2.778 2.135-.212 3.274-.335 3.817-.609 1.332-.674 1.706-2.531 1.81-3.59h7.331c.105 1.059.479 2.916 1.812 3.59.542.274 1.681.398 3.816.609 3.474.344 9.286.92 10.388 2.78 1.676 2.825.498 14.905-.097 19.323a.742.742 0 00-.006.134l.689 14.631z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M47.374 49.496v-4.83h-1.45v4.83l-1.663-1.68-1.025 1.036 2.9 2.933a.719.719 0 001.026 0l2.9-2.933-1.025-1.037-1.663 1.681zM56.075 49.496v-4.83h-1.45v4.83l-1.663-1.68-1.025 1.036 2.9 2.933a.719.719 0 001.025 0l2.9-2.933-1.024-1.037-1.663 1.681zM45.924 41.733h1.45V43.2h-1.45v-1.467zM45.924 38.8h1.45v1.467h-1.45V38.8zM54.625 41.733h1.45V43.2h-1.45v-1.467zM54.625 38.8h1.45v1.467h-1.45V38.8zM54.837 55.148l-2.9 2.933 1.025 1.037 1.662-1.681v4.83h1.45v-4.83l1.663 1.68 1.025-1.036-2.9-2.933a.718.718 0 00-1.025 0zM46.136 55.148l-2.9 2.933 1.025 1.037 1.662-1.681v4.83h1.45v-4.83l1.663 1.68 1.025-1.036-2.9-2.933a.718.718 0 00-1.025 0zM54.625 63.733h1.45V65.2h-1.45v-1.467zM54.625 66.666h1.45v1.467h-1.45v-1.467zM45.924 63.733h1.45V65.2h-1.45v-1.467zM45.924 66.666h1.45v1.467h-1.45v-1.467z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var muscleSpasms = (MuscleSpasms);

;// CONCATENATED MODULE: ./src/components/tepezza/sideEffects/icons/headache.tsx


function Headache() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "103",
        height: "103",
        fill: "none",
        viewBox: "0 0 103 103",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "51.5",
                cy: "51.5",
                r: "51.5",
                fill: "#1E4E35"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_5_91",
                style: {
                    maskType: "alpha"
                },
                width: "50",
                height: "50",
                x: "26",
                y: "27",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26 27H76V77H26z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#fff",
                mask: "url(#mask0_5_91)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M51.575 36.604a.92.92 0 01-.845-1.285l.842-1.95h-.69a.921.921 0 01-.837-1.304l1.482-3.228a.92.92 0 111.673.767l-.884 1.925h.654a.92.92 0 01.845 1.284l-1.395 3.235a.92.92 0 01-.845.556zM59.955 39.468a.92.92 0 01-.78-1.406l1.12-1.803-.682-.103a.92.92 0 01-.633-1.413l1.945-2.974a.92.92 0 011.54 1.008l-1.16 1.772.647.097a.92.92 0 01.645 1.396l-1.86 2.992a.92.92 0 01-.782.434zM66.126 44.837a.919.919 0 01-.545-1.662l1.714-1.256-.595-.35a.92.92 0 01-.06-1.547l2.914-2.033a.92.92 0 011.052 1.51l-1.737 1.211.564.332a.922.922 0 01.078 1.535l-2.842 2.082a.915.915 0 01-.543.178zM43.595 38.403a.92.92 0 01-.782-.434l-1.86-2.993a.92.92 0 01.645-1.395l.647-.097-1.16-1.773a.92.92 0 111.54-1.007l1.946 2.973a.92.92 0 01-.634 1.413l-.682.103 1.121 1.804a.92.92 0 01-.78 1.406zM36.643 43.324a.914.914 0 01-.543-.178l-2.842-2.082a.92.92 0 01.077-1.535l.564-.332-1.737-1.212a.92.92 0 111.053-1.509l2.914 2.033a.92.92 0 01-.06 1.547l-.596.35 1.714 1.255a.92.92 0 01-.544 1.663zM58.273 75.404a.92.92 0 01-.92-.92v-2.961c0-1.063.82-1.895 1.866-1.895h3.615c.775 0 1.406-.71 1.406-1.585v-4.618c0-1.69.988-2.87 2.402-2.87.405 0 .72-.139.843-.372.15-.283.035-.751-.307-1.253a.647.647 0 01-.028-.043l-3.445-5.707a.918.918 0 01-.132-.476c0-7.016-5.709-12.724-12.724-12.724-3.392 0-6.783 1.372-9.305 3.765-2.58 2.446-4 5.643-4 9.001 0 5.172 1.787 8.05 3.364 10.588 1.306 2.105 2.54 4.091 2.54 6.913v4.237a.92.92 0 01-1.84 0v-4.237c0-2.296-1.049-3.986-2.263-5.942-1.622-2.612-3.64-5.862-3.64-11.558 0-7.917 6.935-14.606 15.144-14.606 7.944 0 14.423 6.393 14.562 14.304l3.302 5.471c.732 1.085.878 2.223.4 3.127-.448.847-1.371 1.353-2.47 1.353-.535 0-.562.857-.562 1.03v4.618c0 1.889-1.456 3.425-3.246 3.425H59.22c-.013.003-.027.018-.027.055v2.96a.92.92 0 01-.92.921z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M50.4 55.724c-3.22 0-5.84-2.62-5.84-5.84 0-3.22 2.62-5.84 5.84-5.84 3.22 0 5.84 2.62 5.84 5.84 0 3.22-2.62 5.84-5.84 5.84zm0-9.84c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M51.384 49.884a.984.984 0 11-1.968 0 .984.984 0 011.968 0z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var headache = (Headache);

// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
;// CONCATENATED MODULE: ./src/components/tepezza/sideEffects/index.tsx










const sideEffectList = [
    {
        title: "Hearing loss",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(hearingLoss, {})
    },
    {
        title: "Problems hearing noises",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(problemsHearingNoises, {})
    },
    {
        title: "Deafness",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(deafness, {})
    },
    {
        title: "Muscle spasms",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(muscleSpasms, {})
    },
    {
        title: "Dry skin",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(skin, {})
    },
    {
        title: "Headache",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(headache, {})
    }, 
];
function SideEffects() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
        featureList: sideEffectList,
        mainTitle: "Tepezza Injuries & Side Effects",
        mainDescription: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "block capitalize",
                    children: "The most common side effects of Tepezza are nausea, diarrhea, fatigue, muscle spasm, dry skin, changes in taste and menstrual changes. The most serious Tepezza side effects are infusion reactions, worsening of inflammatory bowel disease, and hyperglycemia (high blood sugar)."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "block mt-4 color-[#7d7d7d] font-bold text-lg",
                    children: "Other adverse effects that have been associated with Tepezza include:"
                })
            ]
        }),
        classes: {
            mainSectionClasses: "mx-auto lg:max-w-7xl flex justify-center items-start flex-col px-8 ",
            mainTitleClasses: "text-left font-bold leading-10 text-2xl mb-8 mt-20",
            innerSectionClasses: "flex flex-wrap justify-center mt-12 gap-16 mb-20",
            oneBoxClasses: "flex flex-col items-center justify-center w-52 md:w-64 mx-10 text-center",
            titleClasses: "mt-5 capitalize text-sm md:text-lg",
            mainDescriptionClasses: "text-left text-sm md:text-lg leading-8",
            iconClasses: " "
        },
        colors: {
            mainDescriptionColor: (tepezzaVariables_module_default()).tepezzaGrey,
            mainTitleColor: (tepezzaVariables_module_default()).mainColor,
            bgColor: (tepezzaVariables_module_default()).secondaryColor
        }
    });
}


/***/ }),

/***/ 35533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__j6_jF","mainSection":"styles_mainSection__2nFt8","link":"styles_link___4DQd"};

/***/ })

}]);